import React from "react";
import { Tabs } from "antd";
import "../styles/Tabs.css";

const { TabPane } = Tabs;

const Tab = ({ onTabChange, activeKey }) => {
  const handleTabChange = (key) => {
    onTabChange(key);
  };

  return (
    <div className="tabs-container">
      <Tabs
        activeKey={activeKey || "Large Cap"}
        onChange={handleTabChange}
        tabBarGutter={24}
        className="tabs-control"
      >
        <TabPane tab="Large Cap" key="Large Cap" />
        <TabPane tab="Large and Mid" key="Large and Mid" />
        <TabPane tab="Mid Cap" key="Mid Cap" />
        <TabPane tab="Small Cap" key="Small Cap" />
        <TabPane tab="Flexi Cap" key="Flexi Cap" />
        {/* <TabPane tab="Hybrid Funds" key="Hybrid Funds" /> */}
      </Tabs>
    </div>
  );
};

export default Tab;
